import { render, staticRenderFns } from "./IconBlockShield.vue?vue&type=template&id=49cd9748&"
import script from "./IconBlockShield.vue?vue&type=script&lang=js&"
export * from "./IconBlockShield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports